module.exports = __webpack_public_path__ + "static/media/finnovex.4c51bab4.gif";